/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Fmt_3Inputs */

const en_pc_online_fmt_3 = /** @type {(inputs: Pc_Online_Fmt_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The desktop app can also create PDFs from images; on Windows the installer adds “Create PDF with PdfCraft…” for PNG, JPEG, TIFF, GIF, BMP and JPEG 2000 files.`)
};

const zh_pc_online_fmt_3 = /** @type {(inputs: Pc_Online_Fmt_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`桌面版还能把图片创建为 PDF；在 Windows 上，安装程序会为 PNG、JPEG、TIFF、GIF、BMP 和 JPEG 2000 文件加入「Create PDF with PdfCraft…」右键菜单。`)
};

/**
* | output |
* | --- |
* | "The desktop app can also create PDFs from images; on Windows the installer adds “Create PDF with PdfCraft…” for PNG, JPEG, TIFF, GIF, BMP and JPEG 2000 files." |
*
* @param {Pc_Online_Fmt_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_fmt_3 = /** @type {((inputs?: Pc_Online_Fmt_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Fmt_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_fmt_3(inputs)
	return zh_pc_online_fmt_3(inputs)
});
export { pc_online_fmt_3 as "pc.online.fmt.3" }